(function(){
  var root=document.querySelector('[data-abc-header]');
  if(!root)return;
  var body=document.body;
  var burger=root.querySelector('.abc-header__burger');
  function closeAllPanels(){
    root.querySelectorAll('.abc-panel.is-open').forEach(function(p){p.classList.remove('is-open');});
    root.querySelectorAll('.abc-menu__trigger[aria-expanded="true"]').forEach(function(t){t.setAttribute('aria-expanded','false');});
  }
  function closeDrawer(){
    root.classList.remove('is-drawer-open');
    body.classList.remove('abc-noscroll');
    if(burger)burger.setAttribute('aria-expanded','false');
    closeAllPanels();
  }
  root.querySelectorAll('.abc-menu__trigger').forEach(function(t){
    t.addEventListener('click',function(e){
      e.preventDefault();
      var panel=document.getElementById(t.getAttribute('data-target'));
      if(!panel)return;
      var isOpen=panel.classList.contains('is-open');
      closeAllPanels();
      if(!isOpen){panel.classList.add('is-open');t.setAttribute('aria-expanded','true');}
    });
  });
  root.querySelectorAll('.abc-panel__back').forEach(function(b){
    b.addEventListener('click',function(){
      var panel=b.closest('.abc-panel');
      if(!panel)return;
      panel.classList.remove('is-open');
      var t=root.querySelector('.abc-menu__trigger[data-target="'+panel.id+'"]');
      if(t)t.setAttribute('aria-expanded','false');
    });
  });
  if(burger){
    burger.addEventListener('click',function(){
      var open=root.classList.toggle('is-drawer-open');
      burger.setAttribute('aria-expanded',open?'true':'false');
      body.classList.toggle('abc-noscroll',open);
      if(!open)closeAllPanels();
    });
  }
  var dc=root.querySelector('[data-abc-drawer-close]');
  if(dc)dc.addEventListener('click',closeDrawer);
  document.addEventListener('click',function(e){
    if(window.innerWidth<990)return;
    if(!root.contains(e.target))closeAllPanels();
  });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){closeAllPanels();if(root.classList.contains('is-drawer-open'))closeDrawer();}
  });
  var logo=root.querySelector('.abc-header__logo');
  var vid=root.querySelector('.abc-logo__video');
  if(logo&&vid){logo.addEventListener('click',function(){try{vid.currentTime=0;vid.play();}catch(err){}});}
  var lastY=window.scrollY||0;
  var STICK_AT=600;
  function onScroll(){
    var y=window.scrollY||0;
    root.classList.toggle('is-scrolled',y>4);
    if(root.classList.contains('is-drawer-open')){lastY=y;return;}
    root.classList.toggle('is-stuck',y>STICK_AT);
    lastY=y;
  }
  onScroll();
  window.addEventListener('scroll',onScroll,{passive:true});
})();
